/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_OperatingStatementAttributes_Array_ } from '../models/ControllerResponse_OperatingStatementAttributes_Array_';
import type { OperatingStatementAttributes } from '../models/OperatingStatementAttributes';
import type { ParseOSResponse } from '../models/ParseOSResponse';
import type { Record_string_unknown_ } from '../models/Record_string_unknown_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class OperatingStatementService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_OperatingStatementAttributes_Array_ Ok
     * @throws ApiError
     */
    public index(): CancelablePromise<ControllerResponse_OperatingStatementAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/operating_statement',
        });
    }
    /**
     * @param requestBody
     * @returns OperatingStatementAttributes Ok
     * @throws ApiError
     */
    public create(
        requestBody: {
            line_items: Record_string_unknown_;
            as_of_date: string;
            name: string;
        },
    ): CancelablePromise<OperatingStatementAttributes> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/operating_statement',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param type
     * @param formData
     * @returns ParseOSResponse Ok
     * @throws ApiError
     */
    public parse(
        type: 'pdf' | 'excel' | 'csv',
        formData: {
            file: Blob;
        },
    ): CancelablePromise<ParseOSResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/operating_statement/parse',
            query: {
                'type': type,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param id
     * @returns OperatingStatementAttributes Ok
     * @throws ApiError
     */
    public show(
        id: number,
    ): CancelablePromise<OperatingStatementAttributes> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/operating_statement/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns OperatingStatementAttributes Ok
     * @throws ApiError
     */
    public update(
        id: number,
        requestBody: {
            line_items: Record_string_unknown_;
            as_of_date: string;
            name: string;
        },
    ): CancelablePromise<OperatingStatementAttributes> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/operating_statement/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public destroy(
        id: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/operating_statement/{id}',
            path: {
                'id': id,
            },
        });
    }
}
